export default "__VITE_ASSET__CWtWfjGd__"